import { render, staticRenderFns } from "./UploadFilesOnEdit.vue?vue&type=template&id=3307dc14&scoped=true"
import script from "./UploadFilesOnEdit.vue?vue&type=script&lang=js"
export * from "./UploadFilesOnEdit.vue?vue&type=script&lang=js"
import style0 from "./UploadFilesOnEdit.vue?vue&type=style&index=0&id=3307dc14&prod&scoped=true&lang=css"
import style1 from "./UploadFilesOnEdit.vue?vue&type=style&index=1&id=3307dc14&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3307dc14",
  null
  
)

export default component.exports